import { render, staticRenderFns } from "./MidwifeInfoOverview.vue?vue&type=template&id=7dcafe06"
import script from "./MidwifeInfoOverview.vue?vue&type=script&lang=js"
export * from "./MidwifeInfoOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports